// extracted by mini-css-extract-plugin
export default {"Box":"no-iterations-placeholder-module__Box--JR0cX","Text":"no-iterations-placeholder-module__Text--w5nx0","Text_1":"no-iterations-placeholder-module__Text_1--Nszxj"};